var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React, { useContext } from 'react';
import { StyledLinkText } from './LinkText.styled';
import { buildDataAttr, DATA_TEST } from '../../../typings/data';
import { ThemeContext } from 'styled-components';
import { mergeTheme } from '../../../utils/mergeTheme';
import { defaultLinkTextTheme } from './constants';
export const defaultProps = {
  [DATA_TEST]: 'link-text',
  skin: 'gray',
  themeBg: 'light'
};
export const LinkText = _a => {
  var {
    skin = defaultProps.skin,
    themeBg = defaultProps.themeBg,
    href,
    target,
    rel,
    onClick,
    children
  } = _a,
      otherProps = __rest(_a, ["skin", "themeBg", "href", "target", "rel", "onClick", "children"]);

  const props = href ? {
    as: 'a',
    href,
    target
  } : {
    as: 'span',
    onClick,
    role: 'button',
    tabIndex: 0
  };
  const context = useContext(ThemeContext);
  const theme = mergeTheme(defaultLinkTextTheme, context);
  return React.createElement(StyledLinkText, Object.assign({
    themeBg: themeBg,
    theme: theme,
    linkType: "LinkText",
    skin: skin,
    isCursorPointer: !href,
    onClick: onClick,
    rel: rel
  }, props, buildDataAttr(otherProps, defaultProps)), children);
};